import GroupLayer from '@arcgis/core/layers/GroupLayer';
import get from 'lodash/get';
import includes from 'lodash/includes';

function hasPopupSupport(layer: __esri.Layer): layer is __esri.FeatureLayer {
  return 'createPopupTemplate' in layer;
}

function prependIncidentToTemplate(
  template: __esri.PopupTemplate,
  incident?: string
) {
  if (!incident || !Array.isArray(template.content)) return;

  const incidentText = `<b>Incident:</b> ${incident} <br/>`;

  const alreadyHasIncident = template.content.some((item) =>
    includes(get(item, 'text'), incidentText)
  );
  if (alreadyHasIncident) return;

  // Prepend the new text element
  template.content = [
    { type: 'text', text: incidentText },
    ...template.content,
  ];
}

/**
 * Rebuild popup templates from the live layer schema so newly added service
 * fields (e.g. Priority Score) appear even when the portal item ships a
 * limited popup field list.
 */
export async function arcGisGetOrCreatePopupTemplate(
  layersParam: __esri.Layer[] | __esri.Collection<__esri.Layer>,
  incident?: string
): Promise<void> {
  const layers = 'toArray' in layersParam ? layersParam.toArray() : layersParam;

  await Promise.all(
    layers.map(async (layer) => {
      await layer.load();

      if (layer instanceof GroupLayer) {
        return arcGisGetOrCreatePopupTemplate(layer.layers, incident);
      }

      if (hasPopupSupport(layer)) {
        const template = layer.createPopupTemplate();
        if (template) {
          prependIncidentToTemplate(template, incident);
          layer.popupTemplate = template;
          layer.popupEnabled = true;
        }
      }
    })
  );
}
